import member_mo from "../../../assets/images/member_mo.webp";
import member_pc1 from "../../../assets/images/member_pc1.webp";
import ar_white from "../../../assets/images/ar_white.svg";
import home_white from "../../../assets/images/home_white.svg";

export default function MemberBanner() {
  return (
    <div className="w-full ">
      <div
        className="block md:hidden lg:hidden w-full relative  h-[12rem] mt-16 bg-center bg-cover bg-no-repeat"
        style={{
          backgroundImage: `url(${member_mo})`,
        }}
      >
        <div className="w-full  bg-blue-sky-gradient6 h-[12rem] ">
          <div className="w-full mx-auto flex flex-col gap-2 items-center justify-center pt-16">
            <div className="w-full h-[2.625rem] rounded-[40px] flex items-center justify-around">
              <div className="flex items-center gap-2">
                <img src={home_white} alt="home1" />
                <img src={ar_white} alt="ar" />
              </div>
              <div>
                <p className="text-[1rem] font-normal text-white whitespace-nowrap">
                  Về chúng tôi
                </p>
              </div>
              <img src={ar_white} alt="ar" />
              <div>
                <p className="text-[1rem] font-normal text-white pl-4">
                  Đội ngũ thành viên
                </p>
              </div>
            </div>
            <p className="text-[1.5rem] font-semibold text-white whitespace-nowrap">
              Đội ngũ thành viên
            </p>
          </div>
        </div>
      </div>
      <div
        className="hidden md:block lg:block w-full relative h-[20rem] mt-28 bg-cover bg-no-repeat bg-center"
        style={{
          backgroundImage: `url(${member_pc1})`,
        }}
      >
        <div className="w-full mx-auto bg-blue-sky-gradient6 h-[20rem] ">
          <div className=" flex flex-col gap-2 items-center justify-center w-full mx-auto pt-20">
            <div className="w-full h-[2.625rem] rounded-[40px] flex items-center justify-center ">
              <div className="flex items-center gap-2">
                <img src={home_white} alt="home1" />
                <img src={ar_white} alt="ar" />
              </div>
              <div>
                <p className="text-[1rem] font-normal text-white whitespace-nowrap">
                  Về chúng tôi
                </p>
              </div>
              <img src={ar_white} alt="ar" />
              <div>
                <p className="text-[1rem] font-normal text-white pl-4">
                  Đội ngũ
                </p>
              </div>
            </div>
            <p className="text-[2.25rem] font-semibold text-white">
              Đội ngũ thành viên
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
